World = function(dispatcher) {

	/*---------------------------------------------------
		STATIC VARS
	--------------------------------------------------*/
	
	this.FOV = 70;
	this.MIN = 0.1;
	this.MAX = 600;
	this.ANTIALIAS = false;
	this.ALPHA = true;
	this.AMBIENTCOLOR = 0XFFFFFF;
	this.AMBIENTINTENSITY = 0.4;
	this.POINTS = 1600;

	/*---------------------------------------------------
		VARIABLES
	--------------------------------------------------*/
	this.dispatcher = dispatcher;
	this.fps = 60;
	this.now = 0;
	this.then = Date.now();
	this.interval = 1000 / 60;
	this.delta = 0;

	this.camZ = 2;
	this.container = document.getElementById( "container" );
	this.clock = new THREE.Clock();
	this.lensUpdate = 0;
	this.mens = "Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor";
	this.resized = false;
	//ADD SCOPE TO FUNCTIONS
	this.render = this.render.bindX( this );

	this.init();

};



World.prototype = {

    
	constructor: World,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function(){
		//this.initStats();
		this.initGL();
		this.initLights();
		this.initPostProcessing();
		this.initControls();
		this.initScene();
		this.bindXEvents();
		this.render();
	},

	/*---------------------------------------------------
		FUNCTIONS TO CALL EXTERNALLY
	--------------------------------------------------*/


	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/

	initStats : function() {
		this.stats = new Stats();
		this.stats.setMode( 0 );

		this.stats.domElement.style.position = 'fixed';
		this.stats.domElement.style.left = '0px';
		this.stats.domElement.style.top = '0px';

		document.body.appendChild( this.stats.domElement );
	},

	initGL : function() {
		this.ratio =  (window.devicePixelRatio > 2) ? 2 :  window.devicePixelRatio;

		this.camera  = new THREE.PerspectiveCamera( this.FOV, window.innerWidth / window.innerHeight, this.MIN, this.MAX );
		this.camera.position.z = 2;
		
		this.scene = new THREE.Scene();

		this.renderer = new THREE.WebGLRenderer( { antialias : this.ANTIALIAS, alpha : this.ALPHA } );
		this.renderer.setPixelRatio( this.ratio );
		this.renderer.setSize( window.innerWidth, window.innerHeight );
		this.renderer.domElement.style.position = 'absolute';
		this.renderer.domElement.style.top = 0;
		this.renderer.domElement.style.left = 0;
		this.renderer.autoClear = false;

		this.container.appendChild( this.renderer.domElement );
		TweenMax.fromTo(this.renderer.domElement,1,{ opacity : 0 },{ delay : 0.3, opacity : 1 } );
		
	},

	initLights : function(){
		this.ambientLight = new THREE.AmbientLight( this.AMBIENTCOLOR, 2);
		this.ambientLight.intensity = this.AMBIENTINTENSITY;
		this.scene.add( this.ambientLight );
	},

	initPostProcessing : function(){
		var renderModel = new THREE.RenderPass( this.scene, this.camera );
		var effectCopy = new THREE.ShaderPass( THREE.CopyShader );
		//var effectFilm = new THREE.FilmPass( 0.35, 0.75, 2048, false );
	

		this.effectFXAA = new THREE.ShaderPass( THREE.FXAAShader );
		var width = window.innerWidth || 2;
		var height = window.innerHeight || 2;
		//effectFXAA.uniforms.resolution.value.set( 1 / width, 1 / height );
		this.effectFXAA.uniforms.resolution.value.set( 1 / ( window.innerWidth * this.ratio), 1 / ( window.innerHeight * this.ratio ));
	//	effectCopy.renderToScreen = true;
		//effectFilm.renderToScreen = true;
		
		var effectVignette = new THREE.ShaderPass( THREE.VignetteShader );
		effectVignette.uniforms.offset.value = 0.1;
		effectVignette.uniforms.darkness.value = 0.2;
		effectVignette.renderToScreen = true;
		this.composer = new THREE.EffectComposer( this.renderer );
		this.composer.setSize( window.innerWidth * this.ratio, window.innerHeight * this.ratio );

		this.composer.addPass( renderModel );
		this.composer.addPass( this.effectFXAA );

		this.composer.addPass( effectVignette );
		//this.composer.addPass( effectFilm);
	},

	initControls : function() {
		if(Detectizr.device.type != "desktop"){
			this.controls  = new THREE.DeviceOrientationControls( this.camera );
		}else{
			this.controls = new THREE.OrbitControls( this.camera, this.renderer.domElement );
		}
	},

	initScene : function() {
		//this.stars = new Constellations(this.scene);

		this.universe = new Nebula( this.scene,this.camera );

		this.messageView = new Message3D( this.scene, this.dispatcher, this.POINTS );
		
		this.hotspots = new HotspotsView(this.scene,this.camera,this.dispatcher);
		
	},

	bindXEvents : function(){
		this.dispatcher.addEventListener( EVENTS.CREATE_MESSAGE_3D, this.resetCamera.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.TOGGLE_RENDER, this.togleRender.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.CREATE_MESSAGE_3D, this.resetCamera.bindX( this ) );
		//this.dispatcher.addEventListener( EVENTS.RESIZE, this.resize.bindX( this ) );
	},

	resetCamera : function (){
		if(Detectizr.device.type != "desktop"){
			//this.controls.disconnect();
			//this.camera.rotation.z = 0;
			//this.camera.rotation.y = 0; // Rotates Yaw Object
			//this.camera.rotation.x = 0; // Rotates the Pitch Object
			//this.controls.connect();
			//this.controls.update();
		}
	},

	resizeOnce : function(){
		if(this.resized) return;
		if( (window.orientation === 0) || (window.orientation === 180) ) {
			TweenMax.delayedCall(0.2,function(){
				this.dispatcher.dispatch(EVENTS.UPDATE_OVERLAYANIM);
				this.camera.aspect = window.innerWidth / window.innerHeight;
				this.camera.updateProjectionMatrix();
		
				this.effectFXAA.uniforms.resolution.value.set( 1 / ( window.innerWidth * this.ratio ), 1 / ( window.innerHeight * this.ratio ));
		
				this.renderer.setSize( window.innerWidth, window.innerHeight );
				this.composer.setSize( window.innerWidth *  this.ratio, window.innerHeight *  this.ratio )
				this.renderer.domElement.style.width = window.innerWidth+"px";
				this.renderer.domElement.style.height = window.innerHeight+"px";

			}.bindX(this));
			
			this.resized = true;
		}
		// }else{
		// 	var dif = window.screen.availHeight - window.innerHeight;
		// 	var w = window.screen.availWidth - dif;
		// 	alert("landscape"+w)
		// 	this.camera.aspect = w / window.screen.availHeight;
		// 	this.camera.updateProjectionMatrix();
	
		// 	this.effectFXAA.uniforms.resolution.value.set( 1 / ( w * res ), 1 / ( window.screen.availHeight * res ));
	
		// 	this.renderer.setSize( w, window.screen.availHeight );
		// 	this.composer.setSize( w *  res, window.screen.availHeight *  res )
		// 	this.renderer.domElement.style.width =  window.screen.availHeight+"px";
		// 	this.renderer.domElement.style.height = w+"px";
			

			
		// 	console.log("landscape"+window.innerWidth)
		// }
		
	},
	
	togleRender : function(e,data) {
		console.log(data)
		if(data.pause === true) window.cancelAnimationFrame( this.requestFame );
		else{
			console.log("oplay again")
			this.render();
		} 
	},

	/*---------------------------------------------------
		RENDER
	--------------------------------------------------*/
	
	render : function () {
		this.now = Date.now();
		this.delta = this.now - this.then;

		if ( this.delta > this.interval ) {
			
			if(!this.resized) this.resizeOnce();

			this.controls.update();
		//	this.stats.update();

			//this.stars.render();
			
			this.hotspots.render();
			this.universe.render();
			this.messageView.render();

			this.renderer.clear();
			this.composer.render();

			this.then = this.now - ( this.delta % this.interval );
		}

		this.requestFame = requestAnimationFrame( this.render );
	}
};